var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEntityCreated = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  x: 2,
  y: 2,
  fill: "currentColor",
  fillOpacity: 0.2,
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillOpacity: 0.3,
  d: "M7 7h10v10H7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeOpacity: 0.3,
  strokeWidth: 2,
  d: "M8 8h8v8H8z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 14,
  y: 14,
  fill: "currentColor",
  rx: 2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 6,
  y: 14,
  fill: "currentColor",
  rx: 2
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 14,
  y: 6,
  fill: "currentColor",
  rx: 2
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 6,
  y: 6,
  fill: "currentColor",
  rx: 2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEntityCreated);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSIyIiB5PSIyIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSI0IiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC4yIi8+CiAgPHJlY3QgeD0iNyIgeT0iNyIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC4zIi8+CiAgPHJlY3QgeD0iOCIgeT0iOCIgd2lkdGg9IjgiIGhlaWdodD0iOCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1vcGFjaXR5PSIwLjMiIHN0cm9rZS13aWR0aD0iMiIvPgogIDxyZWN0IHg9IjE0IiB5PSIxNCIgd2lkdGg9IjQiIGhlaWdodD0iNCIgcng9IjIiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogIDxyZWN0IHg9IjYiIHk9IjE0IiB3aWR0aD0iNCIgaGVpZ2h0PSI0IiByeD0iMiIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgPHJlY3QgeD0iMTQiIHk9IjYiIHdpZHRoPSI0IiBoZWlnaHQ9IjQiIHJ4PSIyIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KICA8cmVjdCB4PSI2IiB5PSI2IiB3aWR0aD0iNCIgaGVpZ2h0PSI0IiByeD0iMiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";